"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VolumeIcon = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var VolumeIcon = function VolumeIcon(_ref) {
  var color = _ref.color,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 24 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 24 : _ref$width,
      props = _objectWithoutProperties(_ref, ["color", "height", "width"]);

  return _react2.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: color,
    height: height,
    width: width
  }, props), _react2.default.createElement("path", {
    d: "M11 19.75a.81.81 0 0 1-.47-.16l-4.79-3.84H2a.76.76 0 0 1-.75-.75V9A.76.76 0 0 1 2 8.25h3.74l4.79-3.84a.75.75 0 0 1 1.22.59v14a.77.77 0 0 1-.42.68.78.78 0 0 1-.33.07zm-8.25-5.5H6a.78.78 0 0 1 .47.16l3.78 3V6.56l-3.78 3a.78.78 0 0 1-.47.19H2.75zm16.32 5.57a.74.74 0 0 1-.53-.22.75.75 0 0 1 0-1.06 9.27 9.27 0 0 0 0-13.08.75.75 0 1 1 1.06-1.06 10.76 10.76 0 0 1 0 15.2.74.74 0 0 1-.53.22zm-3.53-3.54a.74.74 0 0 1-.53-.22A.75.75 0 0 1 15 15a4.25 4.25 0 0 0 0-6 .75.75 0 0 1 1.06-1.06 5.76 5.76 0 0 1 0 8.13.74.74 0 0 1-.52.21z",
    "data-name": "Layer 1"
  }));
};

exports.VolumeIcon = VolumeIcon;